import React from 'react';
import PropTypes from 'prop-types';
import Card from 'react-bootstrap/Card';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import './ServiceOfferingCard.css';

class ServiceOfferingCard extends React.Component {
  constructor(props) {
    super(props);
    this.handleClick = this.handleClick.bind(this);
  }

  handleClick(e) {
    e.stopPropagation();
  }

  render() {
    const {
      serviceOffering,
      location,
      description,
      site,
      tooltipDescription,
      onClick,
    } = this.props;

    const filteredSite = site != null && site.match('https') ? site : '';

    return (
      <OverlayTrigger
        placement="top"
        delay={{ show: 500, hide: 100, }}
        overlay={(
          <Tooltip className="service-offering-card-tooltip">
            {tooltipDescription}
          </Tooltip>
        )}
      >
        <Card className="service-offering-card" onClick={onClick}>
          <Card.Body>
            <Card.Title className="service-offering-card-title">
              {serviceOffering}
            </Card.Title>
            <Card.Text className="service-offering-card-location">
              <strong>Location:</strong>
              {` ${location}`}
            </Card.Text>
            <Card.Text>
              <strong>Description:</strong>
              {` ${description}`}
            </Card.Text>
          </Card.Body>
          <Card.Footer className="service-offering-card-actions">
            <a
              href={filteredSite}
              onClick={this.handleClick}
              target="_blank"
              rel="noopener noreferrer"
            >
              {filteredSite}
            </a>
          </Card.Footer>
        </Card>
      </OverlayTrigger>
    );
  }
}

ServiceOfferingCard.defaultProps = {
  site: undefined,
};

ServiceOfferingCard.propTypes = {
  serviceOffering: PropTypes.string.isRequired,
  location: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  site: PropTypes.string,
  tooltipDescription: PropTypes.string.isRequired,
  onClick: PropTypes.instanceOf(Function).isRequired,
};

export default ServiceOfferingCard;
